import React, { Component } from 'react';

import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Table, Button, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { formatMoney } from '../../../lib/util';


const enricher_cols = ({onEditPressed}) => [
    // {
    //     title: "Enricher Name",
    //     dataIndex: "name",
    //     key: 'name'
    // },
    {
        title: "Enricher ID",
        dataIndex: 'id',
        key: 'id'
    },
    // {
    //     title:"",
    //     dataIndex:'id',
    //     key:'action',
    //     render:(id,data)=><Button 
    //     type='link'
    //     onClick={()=>{
    //         typeof onEditPressed==='function'&&onEditPressed(data)
    //     }}>Edit</Button>

    // }
]

const enricher_fields = [
    {
        index: 'id',
        name: "Enricher ID",
        type: 'text',
        show_update:false
    },
    {
        index: 'name',
        name: "Enricher Name",
        type: 'text'
    },
    {
        index: 'output_columns',
        name: "Output Columns",
        type: 'json'
    }
]

class EnrichersView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_visibility: false,
            form_data: {},
            edit_id: null
        };


        this.list_enrichers = RESTExecutor.list().config({
            label: 'enrichers'
        }).connect(props.domains.settings);



        this.post_enrichers = RESTExecutor.post().config({
            label: 'enrichers'
        }).callbacks((success) => {
                this.list_enrichers.execute();

                this.setState({
                    form_visibility: false,
                    form_data: {},
                    edit_id: null
                })
            })
            .connect(props.domains.settings);

        this.patch_enricher=RESTExecutor.patch().config({
            label:'enrichers_detail'
        }).forId("").callbacks((success)=>{
            this.list_enrichers.execute();

                this.setState({
                    form_visibility: false,
                    form_data: {},
                    edit_id: null
                })

        }).connect(props.domains.settings);

    };

    handlePostPatch=(data)=>{
        if(this.state.edit_id){
            this.patch_enricher.forId(this.state.edit_id).execute(data);
        }else{
            this.post_enrichers.execute(data);
        }
    }


    render() {
        let list_enrichers_res=this.list_enrichers.response();
        let list_enrichers_data=list_enrichers_res.result||{};
        let post_enricher_resp = this.post_enrichers.response();
        let patch_enricher_resp= this.patch_enricher.response();
        let rowsMeta=list_enrichers_res.meta||{};


        let rowsData=list_enrichers_data.rows||[];
        let filteredData=JSON.parse(JSON.stringify(rowsData));
        if(this.state.query){
            filteredData=filteredData.filter(({ name="",id="",description="" }) => {
                name = name.toLowerCase();
                id=id.toLowerCase();
                description=description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                ||id.includes(this.state.query.toLowerCase())
                ||description.includes(this.state.query.toLowerCase())
                ;
            });
        }
        return (
            <div>
                <Table 
                scroll={{x:true}}
                loading={list_enrichers_res.fetching}
                columns={enricher_cols({
                })}
                pagination={{
                    showTotal:(total,range)=>`${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    }}
                dataSource={filteredData}
                className='main-table'
                size='small'
                // pagination={{
                //         simple: true,
                //         onChange: (current, size) => {
                //             this.list_enrichers.config({
                //                 params: {
                //                     per_page: size,
                //                     page: current
                //                 }
                //             }).execute();
                //         },
                //         defaultCurrent: 1,
                //         current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                //         // defaultPageSize: 20,
                //         pageSize: (rowsMeta && rowsMeta.requested_count),

                //         total: (rowsMeta && rowsMeta.total_count),
                //         showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                //     }}
                title={()=><div><Row type='flex' justify='space-between' style={{
                    alignItems:'center'
                  }}><Title 
                  type='secondary'
                  level={3}
                  
                  style={{
                    margin:0
                  }}>Enricher List</Title>
                  {/* <Button type='primary' onClick={() => {
                            this.setState({
                                edit_id: null,
                                form_data: {},
                                form_visibility: true
                            })
                        }}>Add New Enricher</Button> */}
                  </Row><br></br>
                    <Row type='flex'
                    justify='space-between'
                    style={{
                    alignItems: 'center',
                    flexWrap: 'nowrap'
                }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                        }}autoFocus
                            value={this.state.query}
                            onChange={(e) => {
                                this.setState({query:e.target.value})
                            }}
                           /> {this.state.query && this.state.query.length > 0 && <Button
                            style={{
                            marginLeft: 4
                        }}
                            type='danger'
                            shape="circle"
                            icon="close-circle"
                            onClick={() => {
                            this.setState({query:null})
                        }}/>}
                    </Row></div>}
                  rowKey={(record)=>record.id}
                />
            </div>
        );
    }

    componentDidMount(){
        this.list_enrichers.execute()
    }
}

export default withDomains(EnrichersView,"settings");
